import React, { useEffect, useState } from 'react';
import CSVReader from "react-csv-reader";
import * as XLSX from "xlsx";

import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import { makeStyles } from "@material-ui/core/styles";
import AddAlert from "@material-ui/icons/AddAlert";
import Close from "@material-ui/icons/Close";
import Delete from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ReplyIcon from '@mui/icons-material/Reply';
import { Box, Input, Typography } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Checkbox, FormGroup, FormControlLabel } from '@mui/material';

import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import SomeSpinner from "components/Somespinner/Somespinner.js"
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Table from "components/Table/Table.js";
import DatePicker from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import useAuth from "hooks/useAuth";
import api from "assets/services/api";
import { Check, Edit } from '@material-ui/icons';


const useStyles2 = makeStyles(styles2);

const styles = {
    margintp: {
        textAlign: "right",
        marginTop: "10px"
    },
    marginDate: {
        marginBottom: "12px",
        marginTop: "12px",
        display: "flex",
        justifyContent: "center"
    },

    colorCard: {
        color: "#000",
        marginBottom: "-1em",
        fontSize: "14px",
        textAlign: "center"
    },
    marginFor: {
        minHeight: "8em",
        marginTop: "-10px"
    },
    dropDown: {
        width: "80%",
        margin: '0 2em 0 2em'
    },
    contentComponent: {
        display: "flex",
        justifyContent: "center",
        textAlign: "center"
    },
    gridContainer: {
        justifyContent: "center"
    }
};

const useStyles = makeStyles(styles);

function ModalAddCobli(props) {
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    };
    const papaparseOptions = {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
    };

    const classes2 = useStyles2();
    const classes = useStyles();

    const { storageId, storageUserType } = useAuth();

    const [br, setBR] = React.useState(false);
    const [controlSnack, setControlSnack] = useState(false);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [index, setIndex] = useState({ id: 0 });
    const [weightNf, setWeightNf] = useState(0);
    const [sells, setSells] = useState([]);
    const [list, setList] = useState([]);

    const [cars, setCars] = useState([]);
    const [carId, setCarId] = useState('');
    const [regions, setRegions] = useState([]);
    const [regionId, setRegionId] = useState(0);
    const [listCar, setListCar] = useState([]);
    const [clientsNotFind, setClientsNotFind] = useState([]);
    const [clientsNotRegion, setClientsNotRegion] = useState([]);
    const [regionsDrop, setRegionsDrop] = useState([]);
    const [rearrengeView, setRearrengeView] = useState(false);

    const [dataRearrenge, setDataRearenge] = useState([]);
    const [headRearrenge, setHeadRearenge] = useState([]);
    const [isEditing, setIsEditing] = useState(null);


    const [indeterminate, setInterminate] = useState(Array(dataRearrenge.length).fill(false));
    const [allRearrengeChecked, setAllRearrengeChecked] = useState(Array(dataRearrenge.length).fill(false));
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };
    useEffect(() => {
        if (controlSnack) showNotification("br");
    }, [controlSnack]);
    useEffect(() => {
        getCarsCobli();
        getRegions();
        getSells();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        getSells();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate]);
    useEffect(() => {
        calculateWeight();
    }, [list]);
    const calculateWeight = () => {
        let total = 0;
        list.forEach(sell => {
            total += parseFloat(sell.weight);
        });
        setWeightNf(total)
    };
    const getCarsCobli = async () => {
        try {
            const response = await api.get(`/routing/cobli/car`);
            if (response.status === 200) {
                setCars(response.data.cars);
                if (response.data.cars.length > 0) setCarId(response.data.cars[0].id);
            };
        } catch (error) {
            console.log(error)
            return alert(`Nao foi possivel carregar rotas: ${error}`);
        };
    };
    async function getRegions() {
        try {
            const response = await api.get(`/region/${storageId}?type=${storageUserType}&perPage=10&page=1&search=`);
            if (response.status === 200) {
                setRegions(response.data.regions || []);
                if (response.data.regions.length > 0) setRegionId(response.data.regions[0].id);
            };
        } catch (error) {

        };
    };
    async function createCobliRoute() {
        let hasError = false;
        let errorMsg = '';
        try {
            for (let i = 0; i < dataRearrenge.length; i++) {
                if (headRearrenge[i].region === "SEM REGIÃO") continue;
                if (dataRearrenge[i].length === 0) continue;
                const body = {
                    addresses: dataRearrenge[i],
                    region: headRearrenge[i].region,
                    carId: headRearrenge[i].id_car,
                    weightTotal: headRearrenge[i].weight_total
                };
                const send = await api.post(`/routing/create/route/${storageId}`, body);
                if (send.status !== 200) {
                    hasError = true;
                    errorMsg = `Erro ao criar rota para região ${headRearrenge[i].region}: ${send.statusText || send.status}`;
                    break;
                }
            }
            if (hasError) {
                alert(errorMsg);
            } else {
                if (props.onHide) props.onHide();
            }
        } catch (error) {
            alert(`Erro ao criar rota: ${error.message || error}`);
        }
    }
    const createList = async (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (file && (file.name.endsWith(".xls") || file.name.endsWith(".xlsx"))) {
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]]; // Carrega a primeira aba
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // Converte para JSON
                console.log('jsonData:', jsonData);
                const orders = [];
                for (let i = 1; i < jsonData.length - 1; i++) {
                    // const cnpj = jsonData[i][6];
                    const fantasy_name = jsonData[i][3];
                    const cnpj = jsonData[i][2];
                    const weight = (jsonData[i][6]).toFixed(2);
                    // const value = jsonData[i][14];
                    // const order = jsonData[i][0];
                    const format_cnpj = cnpj ? cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5") : '';
                    orders.push({ cnpj: format_cnpj, fantasy_name, weight })
                };
                setList(orders);
            };

            reader.readAsArrayBuffer(file);
        } else {
            alert("Por favor, selecione um arquivo .xls ou .xlsx");
        }
    };
    const removeList = (sell) => {
        const removeItem = list.filter(item => item.order != sell.order)
        setList(removeItem)
    };
    function tableData() {
        let table = [];
        for (let i = 0; i < list.length; i++) {
            table[i] = [];
            table[i].push(list[i].fantasy_name);
            table[i].push(list[i].cnpj);
            table[i].push(list[i].weight);
            table[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip
                        id="tooltip-top-start"
                        title="Deletar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => { removeList(list[i]) }}
                        >
                            <Close
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>
                </div >);
        };
        return table;
    };
    const createListCar = (e) => {
        e.preventDefault();
        const confere = listCar.filter(lis => (lis.id_car == carId || lis.id_region == regionId));
        if (confere.length > 0) {
            return alert(`Não é permitido repetição de carro e/ou região`)
        }
        const car = cars.filter(car => car.id == carId);
        const region = regions.filter(region => region.id == regionId);
        const car_per_region = [{ model: car[0].model, license_plate: car[0].license_plate, region: region[0].name, id_car: carId, id_region: regionId }];
        setListCar([...listCar, ...car_per_region]);
    };
    const removeListCar = (car) => {
        const removeItem = listCar.filter(carr => carr.id_car != car.id_car)
        setListCar(removeItem)
    };
    function tableDataCar() {
        let table = [];
        for (let i = 0; i < listCar.length; i++) {
            table[i] = [];
            table[i].push(listCar[i].model);
            table[i].push(listCar[i].license_plate);
            table[i].push(listCar[i].region);
            table[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip
                        id="tooltip-top-start"
                        title="Deletar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => { removeListCar(listCar[i]) }}

                        >
                            <Close
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>
                </div >);
        };
        return table;
    };
    function tableDataRearrengeForClients(data, index, not_aloc) {
        console.log(data, "dataRearrengeForClients")
        let table = [];
        for (let i = 0; i < data.length; i++) {
            table[i] = [];
            table[i].push(
                <FormControlLabel
                    key={data[i].id}
                    control={
                        <Checkbox
                            className={classes.checkbox}
                            checked={data[i].checked}
                            onChange={() => controlCheck(i, index)}
                        />
                    }
                />
            );
            table[i].push(data[i].fantasy_name);
            table[i].push(data[i].cnpj);
            table[i].push(data[i].weight);
           /*isEditing === i ? (
                <>
                    <Form.Label>Endereço</Form.Label>
                    <Form.Control
                        onChange={(event) => editClient(index, i, event.target.value)}
                        type="text"
                        placeholder="Endereço entrega"
                        required
                        value={data[i].address_delivery || ""}
                    />
                </>
            ) : */  table[i].push(data[i].address_delivery || "Não informado");
            table[i].push(
                <div className={classes2.tableActions}>
                    {isEditing === null ? (<Tooltip
                        id="tooltip-top-start"
                        title="Editar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => setIsEditing(i)}
                        >
                            <Edit
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>) : (
                        <Tooltip
                            id="tooltip-top-start"
                            title="Editar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Close"
                                className={classes2.tableActionButton}
                                onClick={() => setIsEditing(null)}
                            >
                                <Check
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.close
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    )
                    }
                </div >);
            table[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip
                        id="tooltip-top-start"
                        title="Deletar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => { removeClientFromRegion(index, i) }}

                        >
                            <Delete
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>
                </div >);
        };
        return table;
    };

    // Função para remover um cliente de uma região específica
    const removeClientFromRegion = (i_region, i_client) => {
        const updatedData = [...dataRearrenge];
        // Remove o cliente do array da região
        updatedData[i_region] = updatedData[i_region].filter((_, idx) => idx !== i_client);

        // Atualiza o peso total da região
        const updatedHead = [...headRearrenge];
        const removedWeight = parseFloat(dataRearrenge[i_region][i_client]?.weight || 0);
        updatedHead[i_region].weight = (parseFloat(updatedHead[i_region].weight) - removedWeight).toFixed(2);

        setDataRearenge(updatedData);
        setHeadRearenge(updatedHead);
    };
    const createRoute = async () => {
        try {
            if (listCar.length === 0 || list.length === 0) {
                return alert(`Selecione carro,região e pedidos`)
            };
            const response = await api.post(`/routing/cobli/organize/${storageId}`, {
                dataRegion: listCar,
                dataOrders: list
            })
            let orders_obj = [];
            let regions_obj = [];
            let regions_drop = [];
            let inter = [];
            console.log('response:', response.data.clients_per_zone);
            if (response.status = 200) {
                for (let rearrenges in response.data.clients_per_zone.clientsByRegion) {
                    orders_obj.push(response.data.clients_per_zone.clientsByRegion[rearrenges].clients);
                    const head = response.data.clients_per_zone.clientsByRegion[rearrenges].car;
                    head.weight = (response.data.clients_per_zone.clientsByRegion[rearrenges].total_weight).toFixed(2);
                    regions_obj.push(head);
                    regions_drop.push(response.data.clients_per_zone.clientsByRegion[rearrenges].car.region);
                };
                setHeadRearenge(regions_obj);
                setDataRearenge(orders_obj);
                setClientsNotFind(response.data.clients_not_find);
                //setClientsNotRegion(response.data.clients_per_zone.not_region);
                setRearrengeView(true);
                setRegionsDrop([...['selecione'], ...regions_drop]);
                // props.loadRouting();
                // props.onHide();
            }
        } catch (error) {
            return alert(`Erro ao adicionar: ${error}`);
        }
    };
    const removeListNotAloc = (client) => {
        const removeItem = clientsNotFind.filter(c => c.cnpj != client.cnpj)
        setClientsNotFind(removeItem)
    };
    const addClientInRegion = (e) => {
        const newRegionIndex = headRearrenge.findIndex(region => region.region === e); // Obtem o índice da nova região
        if (newRegionIndex === -1) return; // Se a região não existir, sair da função

        // Criar uma cópia do estado atual para manipulação
        const updatedDataRearrenge = [...dataRearrenge];
        const updatedHeadRearrenge = [...headRearrenge];

        let totalWeightToMove = 0; // Inicializa o peso total a ser movido
        let originalRegionIndex = null; // Inicializa o índice da região original

        // Percorrer todas as regiões
        updatedDataRearrenge.forEach((region, regionIndex) => {
            // Verificar se é a região atual
            if (regionIndex !== newRegionIndex) {
                // Filtrar clientes que estão checked
                const checkedClients = region.filter(client => client.checked);

                // Calcular o peso total dos clientes que estão sendo movidos
                totalWeightToMove += checkedClients.reduce((sum, client) => sum + parseFloat(client.weight), 0);

                // Remover clientes checked da região atual
                const updatedClients = region.filter(client => !client.checked);

                // Adicionar clientes checked na nova região
                updatedDataRearrenge[newRegionIndex] = [
                    ...updatedDataRearrenge[newRegionIndex],
                    ...checkedClients.map(client => ({
                        ...client,
                        checked: false, // Definindo checked como false ao mover
                        region_name: updatedHeadRearrenge[newRegionIndex].region, // Atualizando o nome da região
                        id_region: updatedHeadRearrenge[newRegionIndex].id_region // Atualizando o id da região
                    }))
                ];

                // Atualizar a região atual
                updatedDataRearrenge[regionIndex] = updatedClients;

                // Se for a região de origem, armazena o índice
                if (originalRegionIndex === null) {
                    originalRegionIndex = regionIndex;
                }
            }
        });

        // Atualizar o peso total da região de origem
        if (originalRegionIndex !== null) {
            const originalRegionWeight = parseFloat(updatedHeadRearrenge[originalRegionIndex].weight);
            updatedHeadRearrenge[originalRegionIndex].weight = (originalRegionWeight - totalWeightToMove).toFixed(2);
        }

        // Atualizar o peso total da nova região
        const newRegionWeight = parseFloat(updatedHeadRearrenge[newRegionIndex].weight);
        updatedHeadRearrenge[newRegionIndex].weight = (newRegionWeight + totalWeightToMove).toFixed(2);

        // Atualizar os estados com as novas matrizes
        setDataRearenge(updatedDataRearrenge);
        setHeadRearenge(updatedHeadRearrenge);
    };
    const controlCheck = (index_client, index_region) => {
        handleChecked(index_region, index_client);
        controlIntermitente(index_region);
    };

    const controlCheckAll = (index_region) => {
        handleCheckedAll(index_region);
        controlIntermitente(index_region);
    };
    const controlIntermitente = (index_region) => {
        let amountChecked = 0;
        dataRearrenge[index_region].forEach(element => {
            if (element.checked) {
                amountChecked += 1;
            }
        });
        const updatedIndeterminate = [...indeterminate];
        updatedIndeterminate[index_region] = amountChecked > 0 && amountChecked < dataRearrenge[index_region].length;
        setInterminate(updatedIndeterminate);

        const updatedAllChecked = [...allRearrengeChecked];
        updatedAllChecked[index_region] = amountChecked === dataRearrenge[index_region].length;
        setAllRearrengeChecked(updatedAllChecked);
    };


    const handleCheckedAll = (groupIndex) => {
        const allChecked = allRearrengeChecked[groupIndex];
        const updatedSelected = [...dataRearrenge];

        updatedSelected[groupIndex] = updatedSelected[groupIndex].map((client) => {
            client.checked = !allChecked; // Atualiza a propriedade
            return client; // Retorna o objeto atualizado
        });

        setDataRearenge(updatedSelected);
    };
    const handleChecked = (groupIndex, itemIndex) => {
        const updatedSelected = [...dataRearrenge];
        updatedSelected[groupIndex][itemIndex].checked = !updatedSelected[groupIndex][itemIndex].checked;
        setDataRearenge(updatedSelected);
    };
    const getSells = async () => {
        console.log('getSells')
        const get_sells = await api.get(`/sells/cobli?initDate=${startDate}`);
        console.log('get_sells:', get_sells);
        let response_sells = [{ nf: 'selecione nf', weight: '0' }];
        for (let i = 0; i < get_sells.data.sells.length; i++) {
            response_sells = [...response_sells, get_sells.data.sells[i]];
        };
        setSells(response_sells);
    };

    const moveNotRegion = async (sell) => {
        if (!sell || !sell.nf) return;

        // Encontrar o índice da região correspondente no headRearrenge
        const regionIndex = headRearrenge.findIndex(region => region.region === "SEM REGIÃO");

        if (regionIndex === -1) {
            alert('Região não encontrada para essa nota fiscal.');
            return;
        }

        // Montar o novo objeto de cliente/pedido a ser adicionado
        const newClient = {
            ...sell,
            region_name: headRearrenge[regionIndex].region,
            id_region: headRearrenge[regionIndex].id_region
        };

        // Atualizar o array dataRearrenge adicionando o novo cliente na região correta
        const updatedDataRearrenge = [...dataRearrenge];
        updatedDataRearrenge[regionIndex] = [...updatedDataRearrenge[regionIndex], newClient];

        // Atualizar o peso total da região
        const updatedHeadRearrenge = [...headRearrenge];
        const currentWeight = parseFloat(updatedHeadRearrenge[regionIndex].weight) || 0;
        const addWeight = parseFloat(sell.weight) || 0;
        updatedHeadRearrenge[regionIndex].weight = (currentWeight + addWeight).toFixed(2);

        setDataRearenge(updatedDataRearrenge);
        setHeadRearenge(updatedHeadRearrenge);
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {rearrengeView ?
                        <Tooltip
                            id="tooltip-top-start"
                            title="Deletar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Close"
                                className={classes2.tableActionButton}
                                onClick={() => { setRearrengeView(false) }}
                            >
                                <ReplyIcon
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.close
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                        :
                        <div>
                        </div>}
                    Adicionar Rota Cobli
                </Modal.Title>
            </Modal.Header>
            <Form >
                <Modal.Body>
                    <GridContainer>
                        {!rearrengeView ?
                            <><GridItem xs={12} sm={6} md={7}>
                                <Card className={classes.marginFor}>
                                    <div style={{ display: 'grid', direction: 'row' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 20% 0 20%' }}>
                                            <p className={classes.colorCard}>Escolher Carro</p>
                                            <p className={classes.colorCard}>Escolher Região</p>
                                        </div>
                                        <div className={classes.marginDate}>
                                            <Form.Control onChange={event => setCarId(event.target.value)} value={carId} as="select" className={classes.dropDown}>
                                                {cars.map(car => (
                                                    <option key={String(car.id)} value={car.id}>{`${car.model} - ${car.license_plate}`}</option>
                                                ))}
                                            </Form.Control>
                                            <Form.Control onChange={event => setRegionId(event.target.value)} value={regionId} as="select" className={classes.dropDown}>
                                                {regions.map(region => (
                                                    <option key={String(region.id)} value={region.id}>{`${region.code} - ${region.name}`}</option>
                                                ))}
                                            </Form.Control>
                                        </div>
                                    </div>
                                    <div style={{ justifyContent: 'center', width: '100%', display: 'flex' }}>
                                        <Button color="info" onClick={(e) => { createListCar(e); }}>
                                            ADICIONAR
                                        </Button>
                                    </div>

                                </Card>
                            </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                    <Card className={classes.marginFor}>
                                        <div className="d-flex justify-content-center">
                                            <CardBody>
                                                <p className={classes.colorCard}>Notas Fiscas</p>
                                            </CardBody>
                                        </div>
                                        <div>
                                            <input type="file" accept=".*" onChange={createList} style={{ display: 'none' }} id="hiddenFileInput" />
                                            <button onClick={(e) => { e.preventDefault(); document.getElementById('hiddenFileInput').click(); }}>
                                                Selecionar Arquivo
                                            </button>
                                            <p>Escolher o CSV do meta para importar</p>
                                        </div>
                                    </Card>
                                </GridItem>

                                <GridItem xs={12} sm={6} md={3}>
                                    <Card className={classes.marginFor}>,
                                        <div className="d-flex justify-content-center">
                                            <CardBody>
                                                <p className={classes.colorCard}>Criar Rota</p>
                                            </CardBody>
                                        </div>
                                        <div className="container" style={{ marginTop: "15px" }}>
                                            <div>
                                                <div style={{ marginTop: "15px" }}>
                                                    Peso total produtos: {parseFloat(weightNf).toFixed(2)} <br />
                                                </div>
                                                <div className="d-flex justify-content-center">
                                                    <Button color="success" onClick={() => { createRoute(); }}>
                                                        Concluir
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </GridItem>

                                <Table
                                    index={index}
                                    tableHeaderColor="primary"
                                    tableHead={["Carro", "Placa", "Região", "Ação"]}
                                    tableData={tableDataCar()}
                                />
                                <Table
                                    index={index}
                                    tableHeaderColor="primary"
                                    tableHead={["Nome Fantasia", "CNPJ", "Peso"]}
                                    tableData={tableData()}
                                />
                            </>
                            :
                            <>
                                <GridItem xs={12} sm={6} md={3}>
                                    <Card className={classes.marginFor}>,
                                        <div className="d-flex justify-content-center">
                                            <CardBody>
                                                <p className={classes.colorCard}>Mover selecionados para região</p>
                                            </CardBody>
                                        </div>
                                        <div className="container" style={{ marginTop: "15px" }}>
                                            <div className={classes2.tableActions}>
                                                <Form.Control onChange={event => addClientInRegion(event.target.value)} value={regionId} as="select" className={classes.dropDown}>
                                                    {regionsDrop.map((region, index) => (
                                                        <option key={String(index)} value={region}>{`${region}`}</option>
                                                    ))}
                                                </Form.Control>
                                            </div>
                                        </div>
                                    </Card>
                                </GridItem>  <GridItem xs={12} sm={6} md={5}>
                                    <Card className={classes.marginFor}>
                                        <div className="d-flex justify-content-center">
                                            <CardBody >
                                                <p className={classes.colorCard}>Notas Fiscas</p>
                                            </CardBody>
                                        </div>
                                        <div className={classes.marginDate}>
                                            <Autocomplete
                                                disablePortal
                                                id="combo-box-demo"
                                                options={sells}
                                                getOptionLabel={(sell) => `${sell.nf}`}
                                                onChange={(e, value) => { moveNotRegion(value) }}
                                                isOptionEqualToValue={(option, value) => option.nf === value}
                                                sx={{
                                                    width: '75%',
                                                    backgroundColor: "white",
                                                    borderRadius: "10px",
                                                    '& .MuiInputBase-root': {
                                                        height: '40px', // ou o valor desejado
                                                        fontSize: '14px', // ou o valor desejado                                      
                                                    }
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </div>
                                        <p className={classes.colorCard}>Selecione uma data</p>
                                        <div className={classes.marginDate}>
                                            <DatePicker
                                                className={classes.marginDate}
                                                selected={startDate}
                                                onChange={(date) => date ? setStartDate(date.withoutTime()) : setStartDate(null)}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Digite ou clique aqui"
                                                disabledKeyboardNavigation
                                                locale={pt} />
                                        </div>
                                    </Card>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <Card className={classes.marginFor}>,
                                        <div className="d-flex justify-content-center">
                                            <CardBody>
                                                <p className={classes.colorCard}>Criar Rota</p>
                                            </CardBody>
                                        </div>
                                        <div className="container" style={{ marginTop: "15px" }}>
                                            <div>
                                                <div style={{ marginTop: "15px" }}>
                                                    Peso total produtos: {parseFloat(weightNf).toFixed(2)} <br />
                                                </div>
                                                <div className="d-flex justify-content-center">
                                                    <Button color="success" onClick={() => { createCobliRoute() }}>
                                                        Enviar Cobli
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </GridItem>

                                <GridItem xs={12} sm={12} md={12}>
                                    {/*<Card className={classes.marginFor}>
                                        <div className="d-flex justify-content-center">
                                            <CardBody>
                                                <p className={classes.colorCard}>CLIENTES SEM CADASTRO</p>
                                            </CardBody>
                                        </div>
                                        <div className="container" style={{ marginTop: "15px" }}>
                                            <Table
                                                index={index}
                                                tableHeaderColor="primary"
                                                tableHead={["Nome Fantasia", "CNPJ", "Peso", "Endereço entrega", "Ação"]}
                                                tableData={tableDataRearrenge(clientsNotFind)}
                                            />
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <CardBody>
                                                <p className={classes.colorCard}>CLIENTES SEM REGIÃO</p>
                                            </CardBody>
                                        </div>
                                        <div className="container" style={{ marginTop: "15px" }}>
                                            <Table
                                                index={index}
                                                tableHeaderColor="primary"
                                                tableHead={["Nome Fantasia", "CNPJ", "Peso", "Endereço entrega", "Ação"]}
                                                tableData={tableDataRearrenge(clientsNotRegion, 0, true)}
                                            />
                                        </div>
                                    </Card>*/}
                                    {dataRearrenge.map((data, index) => {
                                        return (
                                            <Card className={classes.marginFor}>,
                                                <CardBody>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={allRearrengeChecked[index]}
                                                                    indeterminate={indeterminate[index]}
                                                                    onChange={() => controlCheckAll(index)}
                                                                />
                                                            }
                                                        />
                                                        <Box sx={{ display: 'grid', width: '100%', justifyContent: "center", textAlign: 'center' }}>
                                                            <Typography variant='h5'>{headRearrenge[index].region}</Typography>
                                                            <Typography variant='h6'>{headRearrenge[index].weight} KG</Typography>
                                                            <Typography variant='body1'>{headRearrenge[index].model}</Typography>
                                                        </Box>
                                                    </Box>

                                                </CardBody>
                                                <div className="container" style={{ marginTop: "15px" }}>
                                                    <Table
                                                        index={index}
                                                        tableHeaderColor="primary"
                                                        tableHead={["Selecionar", "Nome Fantasia", "CNPJ", "Peso", "Endereço entrega", "Ação"]}
                                                        tableData={tableDataRearrengeForClients(data, index)}
                                                    />
                                                </div>
                                            </Card>
                                        )
                                    })}
                                </GridItem>
                            </>

                        }
                    </GridContainer>
                </Modal.Body>
                <Modal.Footer>
                    <Snackbar
                        place="br"
                        color="success"
                        icon={AddAlert}
                        message={"Rota criada com sucesso!"}
                        open={br}
                        closeNotification={() => setBR(false)}
                        close
                    />

                    {loading ?
                        <div>
                            <SomeSpinner />
                        </div> :
                        <div></div>
                    }
                </Modal.Footer>
            </Form>
        </Modal >
    );
}

export default ModalAddCobli;